import {
	setCleanForm,
	setEmailDomainBlocked,
	setRedirect,
	setUserExists,
	submitForm,
	updateField,
	updateForm,
} from "./actions";
import { useDispatch } from "react-redux";
import { SOURCE_SUBMIT, SOURCE_SUBMIT_WITHOUT_USER } from "./Subscription";
import { submitEmailExists } from "./api";
import { useSteps } from "./steps/useSteps";

export default function useFormActions() {
	const dispatch = useDispatch();
	const { onSetStepsCount } = useSteps();

	const onCheckIfUserExists = (email) => {
		return new Promise((resolve) => {
			const onSuccess = (data) => {
				const userExists = Boolean(data.userExists);
				const isDomainBlocked = Boolean(data.isDomainBlocked);
				dispatch(setUserExists(userExists));
				dispatch(setEmailDomainBlocked(isDomainBlocked));
				onSetStepsCount(userExists ? 4 : 5);
				resolve({ userExists, isDomainBlocked });
			};

			submitEmailExists(
				{ email },
				onSuccess,
				() => resolve({ userExists: false, isDomainBlocked: false }), // FIXME: Add error handling
			);
		});
	};

	const onUpdateField = (fieldKey, value) => {
		dispatch(updateField(fieldKey, value));
	};

	const onUpdateForm = (data) => {
		dispatch(updateForm(data));
	};

	const onSubmitForm = (source = SOURCE_SUBMIT, namespace = "subscribe") => {
		dispatch(submitForm(source, namespace));
	};

	const onLeaveForm = () => {
		dispatch(setCleanForm());
		onSubmitForm(SOURCE_SUBMIT_WITHOUT_USER);
		dispatch(setRedirect());
	};

	return {
		onLeaveForm,
		onCheckIfUserExists,
		onSubmitForm,
		onUpdateField,
		onUpdateForm,
	};
}
